import React from "react";

export default function TermsOfService() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Terms of Service</h1>
        <p style={styles.updated}>Last updated: July 13, 2025</p>

        <section style={styles.section}>
          <h3 style={styles.subheading}>1. Overview</h3>
          <p style={styles.text}>
            Welcome to my personal portfolio website. By accessing or using this site, you agree to the following terms and conditions. This site showcases my development work, projects, achievements, and related content.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subheading}>2. Personal Use Only</h3>
          <p style={styles.text}>
            This website is intended for personal and informational use only. You may browse, view, and share the content for non-commercial purposes, but you may not replicate or misuse any part of this site for your own gain without permission.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subheading}>3. Intellectual Property</h3>
          <p style={styles.text}>
            All code samples, designs, logos, text, and media displayed on this site are the intellectual property of <strong>Karanks1436</strong>, unless otherwise credited. Reproduction or use of any content without proper attribution is prohibited.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subheading}>4. Accuracy of Information</h3>
          <p style={styles.text}>
            While I strive to keep the content accurate and up-to-date, I make no guarantees about the completeness, accuracy, or reliability of any information on this site.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subheading}>5. External Links</h3>
          <p style={styles.text}>
            This website may include links to external websites (e.g., GitHub, YouTube, LinkedIn). I am not responsible for the content or practices of these third-party sites.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subheading}>6. Changes to Terms</h3>
          <p style={styles.text}>
            I reserve the right to update these terms at any time. Any updates will be posted on this page with the last updated date.
          </p>
        </section>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "#f9f9f9",
    padding: "60px 20px",
    minHeight: "100vh",
  },
  container: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px",
    maxWidth: "850px",
    margin: "auto",
    boxShadow: "0 0 30px rgba(0,0,0,0.05)",
    fontFamily: "'Segoe UI', sans-serif",
    color: "#333",
  },
  heading: {
    fontSize: "36px",
    marginBottom: "10px",
    color: "#111",
    fontWeight: "bold",
  },
  updated: {
    fontSize: "14px",
    color: "#888",
    marginBottom: "30px",
  },
  section: {
    marginBottom: "30px",
  },
  subheading: {
    fontSize: "22px",
    marginBottom: "8px",
    color: "#222",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.8",
    color: "#555",
  },
};
